import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ModalSnackbarService } from '../services/modal-snackbar.service';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const modal = inject(ModalSnackbarService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const apiError = error.error;

      if (apiError?.success === false && typeof apiError.status === 'number') {
        const status = apiError.status;
        const body = apiError.body;
        const msg = typeof body === 'string'
          ? body
          : body?.message || 'エラーが発生しました';

        switch (status) {
          case 401:
            modal.show('認証エラー：再ログインしてください', '/login', 5000, 300);
            break;
          case 403:
            modal.show('アクセス権がありません：再ログインしてください', '/login', 5000, 300);
            break;
          case 419:
            modal.show('セッションの有効期限が切れました：再ログインしてください', '/login', 5000, 300);
            break;
          default:
            modal.show(`エラー: ${msg}`, undefined, 5000, 300);
            break;
        }
      } else {
        if (apiError?.message) {
          modal.show('通信エラーが発生しました\n\n' + apiError.message, undefined, 5000, 300);
        }
        else if (apiError?.detail) {
          modal.show('通信エラーが発生しました\n\n' + apiError.detail, undefined, 5000, 300);
        }
        else {
          modal.show('通信エラーが発生しました', undefined, 5000, 300);
        }
      }

      return throwError(() => error);
    })
  );
};
